import React, { useEffect } from "react";
import { Popup } from "react-map-gl";
import { Box } from "@mui/material";
import { Feature } from "geojson";
import { EVENT_TYPES, FALLBACK_ALERT } from "./WeatherAlertsUtils";

import { AlertHeaderBanner } from "./AlertHeaderBanner";
import { RiskViewerKind, useRiskViewerStateKind } from "../../features/riskViewer/riskViewerSlice";

type WeatherAlertPopupProps = {
    alerts: Array<Feature>,
    lat: number,
    lng: number,
};

export const WeatherAlertPopup: React.FC<WeatherAlertPopupProps> = ( {
    alerts,
    lat,
    lng,
} ) =>
{

    const alert = alerts[0];
    const eventType = alert?.properties?.event as keyof typeof EVENT_TYPES;
    const eventConfig = alert?.properties?.event !== undefined ? ( EVENT_TYPES[eventType] ?? FALLBACK_ALERT ) : undefined;
    const borderColor = eventConfig?.color !== undefined ? eventConfig?.color : "#b00020";
    const riskViewerStateKind = useRiskViewerStateKind();
    const isSelectionState = riskViewerStateKind === RiskViewerKind.SELECTION_STATE;

    useEffect( () =>
    {
        const popups = document.querySelectorAll( ".weather-alert-popup" );
        popups.forEach( popup =>
        {
            ( popup as HTMLElement ).style.setProperty( "--popup-color", borderColor );
        } );
    }, [ borderColor ] );

    if ( alert === undefined )
    {
        return null;
    }

    return (
        <Popup latitude = {lat} longitude = {lng} closeButton = {false} closeOnClick = {false} className = "weather-alert-popup">
            <Box
                sx = {{
                    maxWidth: "250px",
                    padding: "10px",
                    backgroundColor: "white",
                    color: "black",
                    borderRadius: "10px",
                    boxShadow: "0px 8px 20px rgba(0,0,0,0.2)",
                    border: `3px solid ${borderColor}`,
                    position: "relative",
                    transition: "border-color 0.3s ease-in-out",
                    overflow: "hidden"
                }}
            >
                <Box>
                    {alerts.map( ( alertFeature, index ) =>
                    {
                        const featureProps = alertFeature?.properties;
                        const featureEventType = featureProps?.event as keyof typeof EVENT_TYPES;
                        const featureEventConfig = featureProps?.event !== undefined ? ( EVENT_TYPES[featureEventType] ?? FALLBACK_ALERT ) : undefined;
                        const color = featureEventConfig?.color ?? "#b00020";

                        return (
                            <Box key = {index} mb = {1}>
                                <AlertHeaderBanner eventType = {featureEventType} color = {color}/>
                            </Box>
                        );
                    } )}

                    {!isSelectionState &&
                        <Box
                            sx = {{
                                textAlign: "center",
                                color: "gray",
                                fontSize: "12px",
                                marginTop: 2,
                            }}
                        >
                            Click on the map to see more details.
                        </Box>}
                </Box>

            </Box>
        </Popup>
    );
};
